<div>
  <div [ngSwitch]="item.type" class="template-icon">
    <div *ngSwitchCase="'heading'" class="template-heading-icon">
      <div></div>
    </div>
    <div *ngSwitchCase="'text'" class="template-text-icon">
      <img src="https://k16-hosted-lib.s3.us-east-2.amazonaws.com/icons/texticon.jpg" alt="text icon" />
    </div>
    <div *ngSwitchCase="'link'" class="template-link-icon">
      <div></div>
    </div>
    <div *ngSwitchCase="'anchor'" class="template-link-icon">
      <div></div>
    </div>
    <div *ngSwitchCase="'item_link'" class="template-link-icon">
      <div></div>
    </div>
    <div *ngSwitchCase="'file_link'" class="template-link-icon">
      <div></div>
    </div>
    <div *ngSwitchCase="'attachment'" class="template-link-icon">
      <div></div>
    </div>
    <div *ngSwitchCase="'break'">
      <hr />
    </div>
    <div *ngSwitchCase="'panel'" class="template-panel-icon">
      <app-view-icon *ngFor="let it of item.content | slice:0:3; let i=index" [item]="it"></app-view-icon>
      <div class="clearfix"></div>
    </div>
    <div *ngSwitchCase="'conditional'" class="template-panel-icon">
    </div>
    <div *ngSwitchCase="'accordion'" class="template-accordion-icon">
      <div *ngFor="let item of item.tabs"></div>
    </div>
    <div *ngSwitchCase="'tabs'" class="template-tabs-icon">
      <div *ngFor="let item of item.tabs"></div>
    </div>
    <div *ngSwitchCase="'flex'">
      <div class="flex-row">
        <div *ngFor="let list of item.content; let $index = index" [ngClass]="getFlexClass(list)">
          <app-view-icon *ngFor="let it of list.content | slice:0:3; let i=index" [item]="it"></app-view-icon>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="'youtube'" class="template-video-icon">
      <img src="https://k16-hosted-lib.s3.us-east-2.amazonaws.com/icons/videoicon.jpg" alt="text icon" />
    </div>
    <div *ngSwitchCase="'iframe'" [ngClass]="item.size" class="template-video-icon">
      <img src="https://k16-hosted-lib.s3.us-east-2.amazonaws.com/icons/videoicon.jpg" alt="text icon" />
    </div>
    <div *ngSwitchCase="'image'" class="template-image-icon">
      <img src="https://k16-hosted-lib.s3.us-east-2.amazonaws.com/icons/imageicon.jpg" alt="text icon" />
    </div>
    <div *ngSwitchCase="'file_image'" class="template-file-icon">
    </div>
    <div *ngSwitchCase="'container'" class="template-container-icon">
      <app-view-icon *ngFor="let it of item.content | slice:0:3; let i=index" [item]="it"></app-view-icon>
      <div class="clearfix"></div>
    </div>
    <div *ngSwitchCase="'well'" class="template-well-icon">
      <app-view-icon *ngFor="let it of item.content | slice:0:3; let i=index" [item]="it"></app-view-icon>
      <div class="clearfix"></div>
    </div>
    <div *ngSwitchCase="'block_style'" class="template-container-icon">
      <app-view-icon *ngFor="let it of item.content | slice:0:3; let i=index" [item]="it"></app-view-icon>
      <div class="clearfix"></div>
    </div>
    <div *ngSwitchCase="'padding'" class="template-container-icon">
      <app-view-icon *ngFor="let it of item.content | slice:0:3; let i=index" [item]="it"></app-view-icon>
      <div class="clearfix"></div>
    </div>
    <div *ngSwitchCase="'carousel'" class="template-image-icon">
    </div>
    <div *ngSwitchCase="'row'" class="template-row-icon">
      <div class="row">
        <div *ngFor="let list of item.content; let $index = index" class="col-md-{{item.widths[$index]}}">
          <app-view-icon *ngFor="let it of list | slice:0:3; let i=index" [item]="it"></app-view-icon>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="'wizard'" class="template-wizard-icon">
      <i class="fas fa-compass"></i>
    </div>

    <div *ngSwitchDefault>

    </div>
  </div>
  <div class="clearfix"></div>
</div>
